var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import TemplateContinueLinkApi from '../components/TemplateContinueLinkApi';
import TemplateProviderSelection from '../components/TemplateProviderSelection';
import JobForm from './JobForm';
import ManualInstructions from './ManualInstructions';
import BankInfo from './BankInfo';
import TemplateSearch from '../components/TemplateSearch';
import TemplateConfirmationLinkApi from '../components/TemplateConfirmationLinkApi';
import TemplateEdge from '../components/TemplateEdgeNative/TemplateEdgeNative';
import TemplateADPIframe from '../components/TemplateADPIframe';
import TemplateAppClip from '../components/TemplateAppClip';
/**
 * This component is used to route between various templates returned from Link API.
 * Currently, a template is only associated with `next` and `next_with_error`
 * response types.
 *
 * NOTE: Little to no logic should be written inside this component. This component
 * should merely choose which view to show based on the results of the main React hook.
 */
var JobTemplate = function (_a) {
    var linkApiResponse = _a.linkApiResponse, submitStep = _a.submitStep, extraControlsTop = _a.extraControlsTop, extraControlsBottom = _a.extraControlsBottom;
    if (linkApiResponse.template.templateType === 'form')
        return (React.createElement(JobForm, { linkApiResponse: __assign(__assign({}, linkApiResponse), { template: linkApiResponse.template }), extraControlsTop: extraControlsTop, extraControlsBottom: extraControlsBottom, onSubmit: submitStep }));
    if (linkApiResponse.template.templateType === 'bank_info')
        return React.createElement(BankInfo, { onSubmit: submitStep });
    if (linkApiResponse.template.templateType === 'continue') {
        return (React.createElement(TemplateContinueLinkApi, { linkApiResponse: __assign(__assign({}, linkApiResponse), { template: linkApiResponse.template }), onSubmit: submitStep }));
    }
    if (linkApiResponse.responseType === 'next' &&
        linkApiResponse.template.templateType === 'manual_instructions')
        return React.createElement(ManualInstructions, null);
    if (linkApiResponse.template.templateType === 'provider_selection')
        return (React.createElement(TemplateProviderSelection, { linkApiResponse: __assign(__assign({}, linkApiResponse), { template: linkApiResponse.template }), submitStep: submitStep }));
    if (linkApiResponse.template.templateType === 'adp_iframe')
        return (React.createElement(TemplateADPIframe, { linkApiResponse: __assign(__assign({}, linkApiResponse), { template: linkApiResponse.template }) }));
    if (linkApiResponse.template.templateType === 'search')
        return (React.createElement(TemplateSearch, { linkApiResponse: __assign(__assign({}, linkApiResponse), { template: linkApiResponse.template }), submitStep: submitStep }));
    if (linkApiResponse.template.templateType === 'confirmation')
        return (React.createElement(TemplateConfirmationLinkApi, { linkApiResponse: __assign(__assign({}, linkApiResponse), { template: linkApiResponse.template }), onSubmit: submitStep }));
    if (linkApiResponse.template.templateType === 'edge_native')
        return (React.createElement(TemplateEdge, { submitStep: submitStep, webviewUrl: linkApiResponse.template.webviewUrl, fieldKey: linkApiResponse.template.fieldKey, successCriteria: linkApiResponse.template.successCriteria }));
    if (linkApiResponse.template.templateType === 'app_clip') {
        var _b = linkApiResponse.template, appClipInitializationToken = _b.appClipInitializationToken, appClipSkipAction_1 = _b.appClipSkipAction;
        return (React.createElement(TemplateAppClip, { appClipInitializationToken: appClipInitializationToken, skipAppClip: function () {
                submitStep(appClipSkipAction_1.payload);
            } }));
    }
    return null;
};
export default JobTemplate;
